import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M16.516 2.752a1 1 0 0 1 .11.01l.025.004a1 1 0 0 1 .12.035l.04.019a1 1 0 0 1 .076.04q.026.015.05.032a.8.8 0 0 1 .153.148l.018.022q.014.021.027.043.07.113.098.243l.004.027a1 1 0 0 1 .01.104q.001.018.001.035a.8.8 0 0 1-.04.235l-4.9 14a.75.75 0 0 1-1.393.056l-2.683-6.037-6.036-2.682a.75.75 0 0 1 .056-1.393l14-4.9a.8.8 0 0 1 .264-.041m-6.821 8.614 1.822 4.101 3.188-9.11zM4.533 8.483l4.101 1.822 5.012-5.011z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSend;
